<template>
  <div class="jrtt-ad-batch-container">
    <label class="ad-name">广告名称：</label>
    <el-input v-model="adData.name" placeholder="请输入广告名称" size="mini" style="width: 300px;" />
    <span class="named-insert">
      <span>通配符：</span>
      <el-link :underline="false" @click="insertStr('{定向包名}')">+定向包名</el-link>
      <el-link :underline="false" @click="insertStr('{游戏包名}')">+游戏包名</el-link>
      <el-link :underline="false" @click="insertStr('{广告版位}')">+广告版位</el-link>
    </span>
    <!-- 广告状态 -->
    <span class="ml-20">
      <label class="mr-10">{{ adData.operation.label }}</label>
      <el-radio-group v-model="adData.operation.value" size="mini">
        <el-radio-button
          v-for="(item, index) in adData.operation.options"
          :key="index"
          :label="item.value"
        >{{ item.label }}</el-radio-button>
      </el-radio-group>
    </span>
    <el-button type="success" plain size="mini" style="float: right; margin-left: 10px;" @click="openTemplateList('promotion')">读取模板</el-button>
    <el-button type="primary" plain size="mini" style="float: right" @click="openTemplateDialog('promotion')">保存模板</el-button>
    <div class="ad-container">
      <div v-for="(col, cKey) in 2" :key="cKey" class="ad-column">
        <div
          v-for="(item, key, i) in adFilterData"
          :key="key"
        >
          <el-card
            v-if="(cKey === 0 && i < 3) || (cKey === 1 && i >= 3)"
            v-show="!item.hidden"
            style="margin: 10px;"
            shadow="never"
          >
            <div style="display: flex; justify-content: space-between;">
              <h2>{{ item.title }}</h2>
              <div style="display: flex; align-items: center;">
                <el-button type="primary" plain size="mini" @click="openTemplateDialog(key, i)">保存模板</el-button>
                <el-button type="success" plain size="mini" @click="openTemplateList(key)">读取模板</el-button>
              </div>
            </div>
            <app-form
              :ref="'ad_form'"
              :form-data="item.config"
              :submit-request="onSubmit"
              :is-show-button="false"
              default-label-width="120px"
            >
              <template #custom="{form_item, form_key}">
                <!-- 不存在组件类型 -->
                <div v-if="!form_item.type">
                  <!-- 素材 -->
                  <div v-if="form_key === 'material'">
                    <el-button icon="el-icon-video-camera-solid" @click="openMaterialBox('video')">添加视频</el-button>
                    <el-button icon="el-icon-picture" @click="openMaterialBox('image')">添加图片</el-button>
                    <span style="margin-left: 10px">{{ form_item.value.videos.length + form_item.value.images.length }}/{{ form_item.limit }}</span>
                    <el-link
                      v-if="form_item.value.videos.length || form_item.value.images.length"
                      style="float: right"
                      type="primary"
                      @click="form_item.value[form_item.value.tab + 's'] = []"
                    >清空</el-link>
                    <material-list
                      v-model="form_item.value"
                      @replace-cover="replaceCover"
                    />

                    <!-- 素材弹框 -->
                    <material-box
                      v-if="form_item.is_open"
                      advertiser="jrtt"
                      :is-open="form_item.is_open"
                      :type="form_item.box_type"
                      :temp-material="form_item.temp_material"
                      :ad_form_config-basic-config="ad_basic_config"
                      @confirm="materialConfirm"
                      @cancel="materialCancel(form_item)"
                    />
                  </div>

                  <!-- 产品图 -->
                  <div v-if="form_key === 'image_ids'">
                    <el-button icon="el-icon-picture" @click="openMaterialBox('image', form_item)">添加图片</el-button>
                    <span style="margin-left: 10px">{{ form_item.value.images.length }}/{{ form_item.limit }}</span>
                    <el-link
                      v-if="form_item.value.images.length"
                      style="float: right"
                      type="primary"
                      @click="form_item.value.images = []"
                    >清空</el-link>
                    <material-list
                      v-model="form_item.value"
                    />

                    <!-- 产品图片素材弹框 -->
                    <material-box
                      v-if="form_item.is_open"
                      :is-open="form_item.is_open"
                      :type="form_item.box_type"
                      :temp-material="form_item.temp_material"
                      :ad_form_config-basic-config="ad_basic_config"
                      :material-format-id="22"
                      @confirm="productInfoConfirm"
                      @cancel="materialCancel(form_item)"
                    />
                  </div>

                  <!-- 标题 -->
                  <div v-else-if="form_key === 'title'">
                    <title-list :title-data="form_item.value" />
                  </div>

                  <div v-else>
                    {{ form_item.type }}
                  </div>
                </div>
                <!-- 存在组件类型，额外组件类型 -->
                <div v-else>
                  <!-- 输入框列表 -->
                  <div v-if="form_item.type === 'input-list'">
                    <input-list :input-value="form_item.value" v-bind="form_item.props" />
                  </div>

                  <!-- 图片上传列表 -->
                  <div v-if="form_item.type === 'image-list'">
                    <image-list :advertiser-id="adConfig.advertiser_id" :image-list="form_item.value" />
                  </div>

                  <el-button
                    v-if="form_key === 'web_url_material_list' || form_key === 'external_url_material_list'"
                    class="fr"
                    type="primary"
                    @click="openLandingPage(form_key, form_item.label)"
                  >
                    选择已有
                  </el-button>
                  <div v-if="form_key === 'mini_program_info_url'" class="ml-10">
                    <el-button type="primary" @click="openMiniProgramInfoUrl()">选择小游戏链接</el-button>
                  </div>
                </div>
              </template>
            </app-form>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 表格弹框 -->
    <table-box
      v-if="table_box_params.is_show"
      :is-open="table_box_params.is_show"
      :get-table-data="table_box_params.getTableData"
      :pull-data="table_box_params.pullTableData"
      :tablep="table_box_params.tablep"
      :table-list-key="table_box_params.configs"
      :table-box-key="table_box_params.key"
      :title-name="table_box_params.name"
      @confirm="tableBoxConfirm"
      @cancel="tableBoxCancel"
    />
    <!-- 模板弹框 -->
    <templateDialog
      v-if="template_dialog_config.is_show"
      :template-config="template_dialog_config"
      @confirm="confirmTemplateDialog"
    />
    <!-- 模板列表 -->
    <templateList
      v-if="template_list_config.is_show"
      :template-list-config="template_list_config"
      @confirm="applicationTemplate"
    />
    <el-dialog
      v-if="mini_program_info_url_dialog_config.is_show"
      :visible.sync="mini_program_info_url_dialog_config.is_show"
      v-bind="mini_program_info_url_dialog_config.dialog_props"
    >
      <mini-program-info-url
        v-if="mini_program_info_url_dialog_config.is_show"
        v-bind="mini_program_info_url_dialog_config.getters.getProps()"
        @confirm="miniProgramInfoUrlConfirm"
      />
    </el-dialog>
  </div>
</template>

<script>
import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();

import TemplateResource from '@/api/template';
const templateResource = new TemplateResource();

import NativeAnchor from '@/api/tool/nativeAnchor/jrtt';
const nativeAnchor = new NativeAnchor();

import { formDataAssign, findGameById } from '@/tools/form';

export default {
  components: {
    'app-form': () => import('@/components/app-form'),
    'title-list': () => import('../../ad-manage/components/title-list'),
    'material-list': () => import('../../ad-manage/components/material-list'),
    'material-box': () => import('@/components/material-box'),
    'input-list': () => import('../../ad-manage/components/input-list'),
    'image-list': () => import('../../ad-manage/components/image-list'),
    'table-box': () => import('../../ad-manage/components/table-box'),
    'mini-program-info-url': () => import('@/views/superior/jrtt/components/mini-program-info-url'),
    'templateDialog': () => import('./templateDialog.vue'),
    'templateList': () => import('./templateList.vue'),
  },
  props: {
    /** 广告数据 */
    adData: {
      type: Object,
      default: null,
    },
    /** 广告配置 - 传入项目信息 */
    adConfig: {
      type: Object,
      default: null,
    },
  },
  inject: ['aweme_id_map'],
  data() {
    return {
      /** 表格弹框参数 */
      table_box_params: {
        // 是否显示
        is_show: false,
        // 搜索名称
        name: '',
        // 表格存储键值
        key: '',
        // 列表请求参数
        tablep: {},
        // 表头配置数组
        configs: [],
        // 获取表格数据接口
        getTableData: null,
      },
      ad_basic_config: {
        advertiser_ids: [],
        marketing_purpose: 'CONVERSION',
        landing_type: 'APP',
        put_category: 'STANDARD_DELIVERY',
        app_type: 'APP_ANDROID',
      },
      /** 素材 */
      local_materials: {
        image: {},
        video: {},
        video_cover_id: {},
        product: {},
      },
      /** 模板弹窗配置 */
      template_dialog_config: {
        is_show: false,
        name: '',
        type: '',
        is_validate: true,
      },
      /** 模板列表配置 */
      template_list_config: {
        is_loading: false,
        is_show: false,
        type: '',
      },
      /** 广告模板 */
      ad_template: {},
      /** 模板类型表 */
      template_type_map: {
        promotion: 'promotion',
        native_form: 'promotion_identity',
        material_form: 'promotion_materials',
        product_info_form: 'promotion_product_info',
        budget_and_bid_form: 'promotion_budget_and_bid',
        additional_creative_info_form: 'promotion_source',
        anchor_material_list_form: 'promotion_native_anchor',
      },
      /** 动态词包ID */
      word_list_map: {
        '地点': 4,
        '日期': 1727,
        '星期': 1736,
        '年龄': 1737,
      },
      /** 小游戏链接弹窗配置 */
      mini_program_info_url_dialog_config: {
        is_show: false,
        dialog_props: {
          title: '请选择小游戏链接',
          width: '800px',
        },
        getters: {
          getProps: () => {
            const { advertiser_id, target_form: { config: { micro_app_instance_id }}} = this.adConfig;
            return {
              advertiserId: advertiser_id,
              microAppInstanceId: JSON.parse(micro_app_instance_id.value)?.micro_app_instance_id,
            };
          },
        },
      },
    };
  },
  computed: {
    /** 广告表单过滤广告名称参数 */
    adFilterData: function() {
      return Object.fromEntries(Object.entries(this.adData).filter(([key]) => key !== 'name' && key !== 'operation'));
    },
    /** 项目属性值监听列表 */
    projectWatchList: function() {
      const { landing_type, delivery_mode, app_promotion_type } = this.adConfig.basic_set_form.config;
      const { download_type, platform, micro_promotion_type, micro_app_instance_id } = this.adConfig.target_form.config;
      const { external_action, deep_external_action } = this.adConfig.optimize_form.config.optimize_goal.children;
      const { delivery_setting } = this.adConfig.delivery_setting_form.config;
      const { bid_type, deep_bid_type, budget_mode, budget_optimize_switch } = delivery_setting.children;

      return {
        landing_type: landing_type.value,
        download_type: download_type.value,
        platform: platform.value,
        external_action: external_action.value,
        deep_external_action: deep_external_action.value,
        bid_type: bid_type.value,
        deep_bid_type: deep_bid_type.value,
        budget_mode: budget_mode.value,
        budget_optimize_switch: budget_optimize_switch.value,
        delivery_mode: delivery_mode?.value,
        app_promotion_type: app_promotion_type.value,
        micro_promotion_type: micro_promotion_type.value,
        micro_app_instance_id: micro_app_instance_id.value,
      };
    },
  },
  watch: {
    // 监听部分项目属性值变化
    projectWatchList: {
      handler() {
        this.renderForm();
      },
    },
  },
  created() {
    const validatorObj = this.adValidator();
    for (const key in validatorObj) {
      if (validatorObj[key]?.config) {
        this.mergeValidator(this.adData[key].config, validatorObj[key].config);
      }
    }

    this.basicSetEvent();
    this.renderForm();
  },
  methods: {
    /** 基础设置事件监听 */
    basicSetEvent() {
      const { promotion_identity, aweme_id } = this.adData.native_form.config.native_setting.children;
      const { budget, cpa_bid } = this.adData.budget_and_bid_form.config;
      const { anchor_related_type } = this.adData.anchor_material_list_form.config;
      const { anchor_type, anchor_id } = this.adData.anchor_material_list_form.config.anchor_material_list.children;

      // 原生锚点
      anchor_related_type.on = {
        change: () => {
          const is_select = anchor_related_type.value === 'SELECT';
          anchor_type.hidden = !is_select;
          anchor_id.hidden = !is_select;
        },
      };

      anchor_type.on = {
        change: () => {
          let isClearVal = true;
          if (anchor_type.value) {
            this.getNativeAnchor({ advertiser_id: this.adConfig.advertiser_id, anchor_type: anchor_type.value }).then(res => {
              anchor_id.options = res;
              res.forEach(item => {
                if (item.value === anchor_id.value) {
                  isClearVal = false;
                }
              });
              anchor_id.value = isClearVal ? '' : anchor_id.value;
            });
          } else {
            anchor_id.value = '';
            anchor_id.options = [];
          }
        },
      };

      // 推广身份
      promotion_identity.on = {
        change: () => {
          const is_account = promotion_identity.value === 'ACCOUNT_INFO';
          aweme_id.hidden = is_account;
          anchor_related_type.disabled = is_account;
          is_account && (anchor_related_type.value = 'OFF');
          anchor_related_type.on.change();
        },
      };

      // 授权账号
      aweme_id.on = {
        'visible-change': (val) => {
          if (val) {
            this.getAwemeIdOptions();
          }
        },
      };
      // 预算
      budget.on = {
        blur: () => {
          if (typeof budget.value === 'undefined') {
            budget.value = '';
          }
        },
      };

      // 目标转化出价
      cpa_bid.on = {
        blur: () => {
          if (typeof cpa_bid.value === 'undefined') {
            cpa_bid.value = '';
          }
        },
      };
    },
    /** 获取授权账号选项 */
    getAwemeIdOptions() {
      const { aweme_id } = this.adData.native_form.config.native_setting.children;
      if (aweme_id.options.length === 0) {
        if (Object.prototype.hasOwnProperty.call(this.aweme_id_map, this.adConfig.advertiser_id)) {
          aweme_id.options = this.aweme_id_map[this.adConfig.advertiser_id];
        } else {
          aweme_id.props.loading = true;
          this.getTikTokAccount(this.adConfig.advertiser_id).then(res => {
            aweme_id.options = res;
            Object.assign(this.aweme_id_map, {
              [this.adConfig.advertiser_id]: aweme_id.options,
            });
          }).finally(() => {
            aweme_id.props.loading = false;
          });
        }
      }
    },
    /**
     * 打开素材框
     * @param {string} type 素材类型
     */
    openMaterialBox(type, material_item) {
      if (material_item) {
        material_item.temp_material = null;
        material_item.is_open = true;
        material_item.box_type = type;
        material_item.value.tab = type;
      } else {
        const { material } = this.adData.material_form.config.promotion_materials.children;
        material.temp_material = null;
        material.is_open = true;
        material.box_type = type;
        material.value.tab = type;
      }
    },
    /**
     * 更换封面
     * @param item 素材项
     */
    replaceCover(item) {
      const { material } = this.adData.material_form.config.promotion_materials.children;
      material.is_open = true;
      material.box_type = 'image';
      material.temp_material = item;
    },
    /**
     * 素材资源确定返回
     * @param {Array<any>} data 返回数据
     * @param {number} type 返回类型
     */
    materialConfirm(data, type) {
      const { material } = this.adData.material_form.config.promotion_materials.children;

      material.is_open = false;
      if (data.length === 0) {
        return;
      }

      // 更换封面 - 选择多个封面图片，则只保留第一个封面图片
      if (material.temp_material && data.length > 1) {
        data.splice(1);
      }

      // 视频和图片素材不能超过10个！
      const material_const = material.value.images.length + material.value.videos.length;
      if (((material_const + data.length) > material.limit) && !material.temp_material) {
        this.$message.warning(`视频和图片素材不能超过${material.limit}个！`);
        return;
      }

      if (material.value.tab === 'video' && type === 'image') {
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          if (i === 0) {
            material.temp_material.url[0].thumb_url = item.url[0].url;
          } else {
            const temp_material = JSON.parse(JSON.stringify(material.temp_material));
            temp_material.url[0].thumb_url = item.url[0].url;
            material.value['videos'].push(temp_material);
          }
        }
      } else {
        material.value[type + 's'] = material.value[type + 's'].concat(data);
      }
    },
    /** 素材资源取消返回 */
    materialCancel(material) {
      material.is_open = false;
    },
    /**
     * 产品图片资源确定返回
     * @param {Array<any>} data 返回数据
     * @param {number} type 返回类型
     */
    productInfoConfirm(data, type) {
      const { image_ids } = this.adData.product_info_form.config.product_info.children;

      image_ids.is_open = false;
      if (data.length === 0) {
        return;
      }

      // 视频和图片素材不能超过10个！
      const material_const = image_ids.value.images.length;
      if ((material_const + data.length) > image_ids.limit) {
        this.$message.warning(`视频和图片素材不能超过${image_ids.limit}个！`);
        return;
      }

      image_ids.value[type + 's'] = image_ids.value[type + 's'].concat(data);
    },
    /**
     * 打开落地页
     * @param {Array<any>} key 键值
     * @param {Array<any>} title 弹框标题
     */
    openLandingPage(key, title) {
      const { advertiser_id } = this.adConfig;
      this.table_box_params.name = `请选择${title}`;
      this.table_box_params.configs = [{
        name: '名称',
        value: 'name',
      },
      {
        name: `链接`,
        value: 'url',
      }];

      this.table_box_params.getTableData = this.getAllPageList;
      this.table_box_params.pullTableData = this.pullAllPageList;
      this.table_box_params.tablep = {
        advertiser_id,
        page: 1,
        limit: 10,
        name: '',
      };
      this.table_box_params.key = key;
      this.table_box_params.is_show = true;
    },
    /**
     * 表格弹框确定回调
     * @param {Array<any>} list
     */
    tableBoxConfirm(list) {
      this.tableBoxCancel();

      const promotion_materials = this.adData.material_form.config.promotion_materials.children;
      const temp_table_config = promotion_materials[this.table_box_params.key];

      // 不超过列表最大数量
      if (list.length + temp_table_config.value.length <= temp_table_config.props.maxCount) {
        list.forEach(element => {
          temp_table_config.value.push(element.url);
        });
      } else {
        this.$message.warning(`上限为${temp_table_config.props.maxCount}个`);
      }
    },

    /** 表格弹框取消回调 */
    tableBoxCancel() {
      this.table_box_params.is_show = false;
      this.table_box_params.getTableData = null;
    },
    /** 获取落地页 */
    getAllPageList(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getAllPageList(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 同步落地页 */
    pullAllPageList(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .pullAllPageList(params)
          .then((response) => {
            this.$message.success(response.message);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 获取广告主绑定的抖音号 */
    getTikTokAccount: function(advertiser_id) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getTikTokAccountApi({ advertiser_id })
          .then((response) => {
            const format_data = response.map(e => {
              return {
                label: `${e.aweme_name}(${e.aweme_id})`,
                value: e.aweme_id,
              };
            });
            resolve(format_data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 获取广告主的原生锚点ID */
    getNativeAnchor: function(data) {
      return new Promise((resolve, reject) => {
        // 获取锚点列表之前先同步一次
        nativeAnchor.pullNativeAnchorApi({ advertiser_id: data.advertiser_id })
          .finally(() => {
            nativeAnchor
              .getNativeAnchorApi(data)
              .then((response) => {
                const format_data = response.list.map(e => {
                  return {
                    label: `${e.name}(${e.type_id})`,
                    value: e.type_id,
                  };
                });
                resolve(format_data);
              })
              .catch((error) => {
                reject(error);
              });
          });
      });
    },
    /** 渲染表单 */
    renderForm() {
      const { landing_type } = this.adConfig.basic_set_form.config;
      const { download_type, platform, micro_promotion_type, micro_app_instance_id } = this.adConfig.target_form.config;
      const { delivery_setting } = this.adConfig.delivery_setting_form.config;
      const { bid_type, deep_bid_type, budget_mode, budget_optimize_switch } = delivery_setting.children;

      const { budget, cpa_bid, deep_cpabid, roi_goal } = this.adData.budget_and_bid_form.config;
      const { external_url_material_list, web_url_material_list, mini_program_info_url } = this.adData.material_form.config.promotion_materials.children;
      const { anchor_related_type } = this.adData.anchor_material_list_form.config;

      // 【竞价策略】是否为最大转化投放
      const is_no_bid = bid_type.value === 'NO_BID';
      // 【项目预算】是否为日预算
      const is_budget_mode_day = budget_mode.value === 'BUDGET_MODE_DAY';
      // 【预算择优分配】是否开启
      const is_on = budget_optimize_switch.value === 'ON';

      if (bid_type.value) {
        cpa_bid.hidden = is_no_bid;
        deep_cpabid.hidden = !(!is_no_bid && deep_bid_type.value === 'DEEP_BID_MIN' && !deep_bid_type.hidden);
        roi_goal.hidden = !(!is_no_bid && deep_bid_type.value === 'ROI_COEFFICIENT' && !deep_bid_type.hidden);
      }

      // 广告预算
      const is_all = is_no_bid && is_budget_mode_day && is_on;
      budget.props.min = is_all ? 0 : 300;
      budget.props.disabled = is_all;
      budget.value = is_all ? 0 : (budget.value === 0 ? 300 : budget.value);
      budget.hidden = false;

      // 推广目标为应用推广时
      if (landing_type.value === 'APP') {
        // 下载模式为落地页下载时，显示落地页
        external_url_material_list.hidden = download_type.value !== 'EXTERNAL_URL';
        // 平台为安卓，下载模式为直接下载时，显示Android应用下载详情页
        web_url_material_list.hidden = download_type.value !== 'DOWNLOAD_URL' || platform.value !== 'ANDROID';
      }

      /** 推广目标为小游戏时 */
      if (landing_type.value === 'MICRO_GAME') {
        /** 隐藏Android应用下载详情页 */
        web_url_material_list.hidden = true;
        /** 显示普通落地页 */
        external_url_material_list.hidden = false;
      }

      /** 广告来源 */
      const { source } = this.adData.additional_creative_info_form.config;
      /** 广告来源，当landing_type = LINK、MICRO_GAME、SHOP时必填 */
      source.rules.required = landing_type.value === 'MICRO_GAME';

      /** 【投放模式】是自动投放时，不支持【budget】、【cpa_bid】、【deep_cpabid】、【roi_goal】 */
      setTimeout(this.setBudgetAndBidFormProperty, 0);

      /** 【投放模式】是自动投放时，素材数量上限由10增加为30 */
      this.setMaterialLimit();

      /** 【推广目标】是否为小游戏 */
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      /** 【小游戏类型】是否为字节小游戏 */
      const is_byte_game = micro_promotion_type.value === 'BYTE_GAME';
      /** 【字节小游戏】是否有值 */
      const is_has_micro_app_instance_id = !!micro_app_instance_id.value;
      /** 是否为字节小游戏 */
      const is_byte = is_micro_game && is_byte_game && is_has_micro_app_instance_id;
      // 【小游戏链接】显示/隐藏
      mini_program_info_url.hidden = !is_byte;
      // 【落地页】数量限制
      external_url_material_list.props.maxCount = is_byte ? 1 : 10;
      // 【原生锚点】禁选手动选择
      anchor_related_type.options.forEach(opt => opt.value === 'SELECT' && (opt.disabled = is_byte));
      if (is_byte) {
        // 【原生锚点】重置选值
        if (anchor_related_type.value === 'SELECT') {
          anchor_related_type.value = 'OFF';
          anchor_related_type?.on?.change();
        }
      }
    },
    /** 打开模板弹窗 */
    async openTemplateDialog(type, index) {
      let is_validate = false;
      // 清空素材列表 保存新的素材
      Object.assign(this.local_materials, {
        image: {},
        video: {},
        video_cover_id: {},
        product: {},
      });
      // 单个模板效验表单
      if (index || index === 0) {
        this.ad_template = {};
        is_validate = await this.$refs.ad_form[index].confirm(false, false);
      }
      // 整个模板效验表单
      if (type === 'promotion') {
        is_validate = await this.validateAllForm(false, false);
      }
      Object.assign(this.template_dialog_config, {
        is_show: true,
        is_validate,
        type,
        name: '',
      });
    },
    /** 模板弹窗确认 */
    async confirmTemplateDialog() {
      const type = this.template_dialog_config.type;

      if (!this.template_dialog_config.name) {
        this.$message.warning('请输入模板名称！');
        return;
      }
      // 添加素材模板
      Object.assign(this.ad_template, {
        local_materials: this.local_materials,
      });

      const params = {
        advertiser: 'jrtt',
        type: this.template_type_map[type],
        name: this.template_dialog_config.name,
        template_data: JSON.stringify(this.ad_template),
      };
      templateResource.addTemplateData(params).then(res => {
        this.$message.success(res.message);
      });
      this.template_dialog_config.is_show = false;
    },
    /**
     * 打开模板列表
     * @param {string} type 模板类型
     */
    openTemplateList(type) {
      Object.assign(this.template_list_config, {
        is_show: true,
        type,
      });
    },
    /**
     * 应用模板
     * @param {string} data 模板数据
     */
    async applicationTemplate(data) {
      this.template_list_config.is_loading = true;
      const type = this.template_list_config.type;

      const template_data = JSON.parse(data.split(' - ')[1]);
      // 格式化锚点数据
      if (template_data?.promotion_materials?.anchor_material_list && template_data.promotion_materials.anchor_material_list.length) {
        template_data.anchor_material_list = template_data.promotion_materials.anchor_material_list[0];
      }
      // 格式化【原生锚点】
      if (template_data?.native_setting?.anchor_related_type) {
        template_data.anchor_related_type = template_data.native_setting.anchor_related_type;
      }
      // 整体读取项目
      if (type === 'promotion') {
        for (const key in this.adFilterData) {
          formDataAssign(this.adData[key].config,
            (key === 'product_info_form' ? template_data.promotion_materials : template_data));
        }
        Object.assign(this.adData, { name: template_data.name });
        Object.assign(this.adData.operation, { value: template_data.operation });
      } else {
        // 单个读取项目
        formDataAssign(this.adData[type].config,
          (type === 'product_info_form' ? template_data.promotion_materials : template_data));
      }
      // 非原始表单值赋值
      if (template_data.promotion_materials) {
        const { material, title } = this.adData.material_form.config.promotion_materials.children;
        const { image_ids } = this.adData.product_info_form.config.product_info.children;

        // 广告素材
        if (type === 'promotion' || type === 'material_form') {
          // 图片素材
          if (template_data.promotion_materials?.image_material_list) {
            material.value.images = template_data.promotion_materials?.image_material_list?.map(item => {
              return item.images?.map(image_item => {
                return template_data.local_materials.image[image_item.image_id];
              })[0];
            });
            material.value.tab = 'image';
          } else {
            // 清空图片素材
            Object.assign(material.value, {
              images: [],
            });
          }

          // 视频素材
          if (template_data.promotion_materials?.video_material_list) {
            material.value.videos = template_data.promotion_materials?.video_material_list?.map(item => {
              const temp_material = template_data.local_materials.video[item.video_id];

              return temp_material;
            });
            material.value.tab = 'video';
          } else {
            // 清空视频素材，且在图片和视频素材都没有的情况下，tab默认为视频
            let tab = 'image';
            if (material.value.images.length === 0) {
              tab = 'video';
            }
            Object.assign(material.value, {
              videos: [],
              tab,
            });
          }

          // 标题
          if (template_data.promotion_materials?.title_material_list) {
            title.value.list = template_data.promotion_materials?.title_material_list.map(item => {
              return {
                name: item.title,
                is_title_pop: false,
              };
            });
          } else {
            // 清空标题
            Object.assign(title.value, {
              list: [],
            });
          }

          // 小游戏链接
          if (template_data.promotion_materials?.mini_program_info?.url) {
            template_data.promotion_materials.mini_program_info_url = template_data.promotion_materials.mini_program_info?.url;
            delete template_data.promotion_materials.mini_program_info;
          }
        }

        // 产品主图
        if (type === 'promotion' || type === 'product_info_form') {
          // 产品主图素材
          if (template_data.promotion_materials?.product_info?.image_ids?.length) {
            const images = template_data.promotion_materials?.product_info?.image_ids.map(img_id => {
              return template_data.local_materials.product[img_id];
            });
            image_ids.value = { images, tab: 'image' };
          } else {
            // 清空产品主图素材
            image_ids.value = { images: [], tab: 'image' };
          }
        }
      }
      // 原生广告
      if (type === 'promotion' || type === 'native_form') {
        const { promotion_identity, aweme_id } = this.adData.native_form.config.native_setting.children;
        const get_aweme_id = template_data?.native_setting?.aweme_id;
        const isHasAwemeId = get_aweme_id === '' || !!get_aweme_id;

        promotion_identity.value = isHasAwemeId ? 'TIKTOK' : 'ACCOUNT_INFO';
        aweme_id.hidden = !isHasAwemeId;
        this.getAwemeIdOptions();
      }

      // 执行change方法列表
      await this.handleChangeList();
      // 根据项目数据重新渲染广告表单
      this.renderForm();

      Object.assign(this.template_list_config, {
        is_loading: false,
        is_show: false,
      });
    },
    /**
     * 获取动态词包ID
     * @param {string} str 词包字符模板
     */
    getWordListIds(str){
      try {
        const temp_name_list = str.match(/(?<=\{)[^}]*(?=\})/g);
        return temp_name_list ? temp_name_list.map(word => this.word_list_map[word]) : null;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    /** 表单回调 */
    onSubmit(params) {
      if (this.template_dialog_config.type === 'promotion') {
        const { name, operation } = this.adData;
        const { value: projectName } = this.adConfig.basic_set_form.config.name;
        const { alias: { extra_data: { channel_details = {}} = {}} = {}} = this.adConfig.channel_form.config.channel.children;
        const { alias, config: { platform } = {}, game_id } = channel_details;
        const project_name = projectName.concat(`-jrttnew+${alias}++${platform}+${game_id}`);
        Object.assign(this.ad_template, { name: this.formatAdName(name), operation: operation.value, project_name });
      }
      Object.assign(this.ad_template, params);
      const { promotion_identity } = this.adData.native_form.config.native_setting.children;

      const isHasVideos = !!this.ad_template?.promotion_materials?.material?.videos.length;
      const isHasImages = !!this.ad_template?.promotion_materials?.material?.images.length;
      const isHasTitle = !!this.ad_template?.promotion_materials?.title?.list.length;
      const isHasProductInfo = !!this.ad_template?.product_info;
      const isHasCallToActionButtons = !!this.ad_template?.call_to_action_buttons;
      const isTiktok = promotion_identity.value === 'TIKTOK';
      const isHasAnchorRelatedType = !!this.ad_template?.anchor_related_type;
      const isHasMiniProgramInfoUrl = !!this.ad_template?.promotion_materials?.mini_program_info_url;

      const mapTuple = [
        // 是否存在视频
        [
          () => isHasVideos,
          () => {
            this.ad_template.promotion_materials.video_material_list = this.ad_template.promotion_materials.material?.videos.map(item => {
              this.local_materials.video[item.id] = item;
              this.local_materials.video_cover_id[item.id] = item.url[0].thumb_url;
              return {
                image_mode: item.file_mode.code,
                video_id: item.id,
                video_cover_id: item.url[0].thumb_url,
              };
            });
          },
        ],
        // 是否存在图片
        [
          () => isHasImages,
          () => {
            this.ad_template.promotion_materials.image_material_list = this.ad_template.promotion_materials.material?.images.map(item => {
              this.local_materials.image[item.id] = item;
              return {
                image_mode: item.file_mode.code,
                // 图片ID数组，目前仅支持传入1个
                images: [{
                  image_id: item.id,
                }],
              };
            });
          },
        ],
        // 是否存在标题
        [
          () => isHasTitle,
          () => {
            this.ad_template.promotion_materials.title_material_list = this.ad_template.promotion_materials.title?.list.map(item => {
              const word_list = this.getWordListIds(item.name);
              return {
                title: item.name,
                ...(word_list && { word_list }),
              };
            });

            delete this.ad_template.promotion_materials.title;
          },
        ],
        // 是否存在产品信息
        [
          () => isHasProductInfo,
          () => {
            this.ad_template.product_info.image_ids = this.ad_template.product_info.image_ids.images.map(item => {
              this.local_materials.product[item.id] = item;
              return item.id;
            });
            if (this.ad_template.promotion_materials) {
              this.ad_template.promotion_materials.product_info = this.ad_template.product_info;
            } else {
              Object.assign(this.ad_template, {
                promotion_materials: {
                  product_info: this.ad_template.product_info,
                },
              });
            }

            delete this.ad_template.product_info;
          },
        ],
        // 是否存在产品信息 - 行动号召文案
        [
          () => isHasCallToActionButtons,
          () => {
            this.ad_template.promotion_materials.call_to_action_buttons = this.ad_template.call_to_action_buttons;
            if (this.ad_template.promotion_materials) {
              this.ad_template.promotion_materials.call_to_action_buttons = this.ad_template.call_to_action_buttons;
            } else {
              Object.assign(this.ad_template, {
                promotion_materials: {
                  call_to_action_buttons: this.ad_template.call_to_action_buttons,
                },
              });
            }

            delete this.ad_template.call_to_action_buttons;
          },
        ],
        // 推广身份是否选择抖音号
        [
          () => !isTiktok,
          () => {
            delete this.ad_template.native_setting;
          },
        ],
        // 是否存在原生锚点
        [
          () => isHasAnchorRelatedType,
          () => {
            if (this.ad_template.anchor_related_type !== 'OFF') {
              if (isTiktok && this.ad_template?.native_setting) {
                Object.assign(this.ad_template.native_setting, {
                  anchor_related_type: this.ad_template.anchor_related_type,
                });
              } else {
                Object.assign(this.ad_template, {
                  native_setting: {
                    anchor_related_type: this.ad_template.anchor_related_type,
                  },
                });
              }
              if (this.ad_template.anchor_related_type === 'SELECT') {
                if (this.ad_template?.promotion_materials) {
                  Object.assign(this.ad_template.promotion_materials, {
                    anchor_material_list: [{ ...this.ad_template.anchor_material_list }],
                  });
                } else {
                  Object.assign(this.ad_template, {
                    promotion_materials: {
                      anchor_material_list: [{ ...this.ad_template.anchor_material_list }],
                    },
                  });
                }
              }
            }
            delete this.ad_template.anchor_material_list;
            delete this.ad_template.anchor_related_type;
          },
        ],
        // 是否存在小游戏链接
        [
          () => isHasMiniProgramInfoUrl,
          () => {
            Object.assign(this.ad_template.promotion_materials, { mini_program_info: { url: this.ad_template.promotion_materials.mini_program_info_url }});
            delete this.ad_template.promotion_materials.mini_program_info_url;
          },
        ],
      ];
      mapTuple.forEach(([m, n]) => m() && n());

      this.ad_template.promotion_materials && delete this.ad_template.promotion_materials.material;
    },
    /** 效验所有表单 */
    async validateAllForm(is_validate = true, is_filter_empty = true) {
      this.template_dialog_config.type = 'promotion';
      let is_succeed = false;
      let is_all_succeed = true;
      this.ad_template = {};

      for (let i = 0; i < this.$refs.ad_form.length; i++) {
        const item = this.$refs.ad_form[i];
        is_succeed = await item.confirm(is_validate, is_filter_empty);
        if (!is_succeed) {
          is_all_succeed = is_succeed;
          if (is_validate) {
            break;
          }
        }
      }

      return is_all_succeed;
    },
    /** 获取change方法列表 */
    getChangeList(config) {
      let change_list = [];
      for (const config_key in config) {
        const item = config[config_key];
        if (config[config_key].children) {
          const config_list = this.getChangeList(item.children);
          change_list = [
            ...change_list,
            ...config_list,
          ];
        } else if (item.on?.change){
          change_list.push(item.on.change);
        }
      }

      return change_list;
    },
    /** 执行change方法列表 */
    async handleChangeList(){
      let event_list = [];
      for (const key in this.adFilterData) {
        const config = this.adData[key]?.config;
        if (config) {
          const change_list = this.getChangeList(config);

          if (change_list.length){
            event_list = [
              ...event_list,
              ...change_list,
            ];
          }
        }
      }
      try {
        for (let i = 0; i < event_list.length; i++) {
          await event_list[i]();
        }
      } catch (error) {
        console.log(error);
      }
    },
    /** 广告名称插入通配符 */
    insertStr(str) {
      var strArr = this.adData.name.match(/{[^}{]*?}/g);
      let isRepeat = false;
      let re_str = this.adData.name;
      if (strArr && strArr.length) {
        for (var i = 0; i < strArr.length; i++) {
          const item = strArr[i];
          if (item === str) {
            isRepeat = true;
            re_str = re_str.replace(item, '');
            break;
          }
        }
      }
      if (isRepeat) {
        this.adData.name = re_str;
      } else {
        const {
          audience_template_name,
          delivery_range_template_name,
        } = this.adConfig.project_config.ad_wildcard;
        if (str === '{定向包名}' && !audience_template_name) {
          this.$message.warning('获取不到定向包名称，请保存对应模块为模板！');
          return;
        }
        if (str === '{广告版位}' && !delivery_range_template_name) {
          this.$message.warning('获取不到广告版位名称，请保存对应模块为模板！');
          return;
        }
        const { alias: { extra_data: { channel_details = {}} = {}} = {}} = this.adConfig.channel_form.config.channel.children;
        if (str === '{游戏包名}' && !Object.prototype.hasOwnProperty.call(channel_details, 'game_id')) {
          this.$message.warning('获取不到游戏名称，请先填写渠道！');
          return;
        }
        this.adData.name += str;
      }
    },
    /** 获取字符长度 */
    getStrLen(str) {
      var realLength = 0,
        len = str.length,
        charCode = -1;
      for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) {
          realLength += 1;
        } else {
          realLength += 2;
        }
      }
      return realLength;
    },
    /** 格式化广告名称 */
    formatAdName(name) {
      let realName = '';
      const {
        audience_template_name,
        delivery_range_template_name,
      } = this.adConfig.project_config.ad_wildcard;
      const { alias: { extra_data: { channel_details = {}, games = [] } = {}} = {}} = this.adConfig.channel_form.config.channel.children;
      const matching = {};
      findGameById(games, channel_details.game_id, matching);
      realName = name
        .replace('{定向包名}', audience_template_name)
        .replace('{游戏包名}', matching.name)
        .replace('{广告版位}', delivery_range_template_name);
      return realName;
    },
    /** 合并规则效验方法 */
    mergeValidator(formConfig, data) {
      for (const key in formConfig) {
        const item = formConfig[key];
        // 判断是否存在子级
        if (item.children) {
          this.mergeValidator(item.children, data[key].children);
        } else {
          if (data[key]?.rules) {
            item.rules = data[key].rules;
          }
        }
      }
    },
    /** 规则效验的方法 */
    adValidator() {
      return {
        material_form: {
          config: {
            promotion_materials: {
              children: {
                material: {
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      const { material } = this.adData.material_form.config.promotion_materials.children;
                      const material_num = value.videos.length + value.images.length;
                      if (material_num === 0) {
                        callback(new Error('请选择素材'));
                      } else if (material_num > material.limit) {
                        callback(new Error('素材数量超出上限'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
                // 标题素材
                title: {
                  rules: [
                    {
                      required: true, message: '请选择标题', trigger: [],
                      validator: (rule, value, callback) => {
                        if (value.list.length === 0) {
                          callback(new Error('请选择标题'));
                        } else {
                          callback();
                        }
                      },
                    },
                  ],
                },
                /** 普通落地页链接素材 */
                external_url_material_list: {
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
                /** Android应用下载详情页（用户点击广告中“立即下载”按钮以外的区域时所到达的页面），上限10个 */
                web_url_material_list: {
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
              },
            },
          },
        },
        // 产品信息
        product_info_form: {
          config: {
            product_info: {
              children: {
                titles: {
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('产品名称至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
                image_ids: {
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.images.length !== 0) {
                        callback();
                      } else {
                        callback(new Error('请选择产品主图'));
                      }
                    },
                  },
                },
                selling_points: {
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('产品卖点至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
              },
            },
            // 行动号召文案
            call_to_action_buttons: {
              rules: {
                required: true, trigger: [],
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error('行动号召文案至少添加一个'));
                  } else {
                    callback();
                  }
                },
              },
            },
          },
        },
        // 附加创意信息-表单配置
        additional_creative_info_form: {
          config: {
            /** 广告来源，字数限制：[2-10]（英文字符限制：[4-20]）当landing_type = LINK、MICRO_GAME、SHOP时必填  */
            source: {
              rules: {
                required: true,
                trigger: ['change'],
                validator: (rule, value, callback) => {
                  let len = 0;
                  for (let i = 0; i < value.length; i++) {
                    // 识别中文字符则长度+2，其余字符长度+1
                    if (value.charAt(i).match(/[\u4e00-\u9fa5]/g) != null) {
                      len += 2;
                    } else {
                      len += 1;
                    }
                  }
                  const { landing_type } = this.adConfig.basic_set_form.config;
                  /** 字符长度为0且推广目标不是小游戏时允许通过验证 */
                  if (len === 0 && landing_type.value !== 'MICRO_GAME') {
                    callback();
                  } else if (len > 20 || len < 4) {
                    callback(new Error('字数限制：[2-10]（英文字符限制：[4-20]）'));
                  } else {
                    callback();
                  }
                },
              },
            },
          },
        },
      };
    },
    /** 设置【广告预算与出价】表单属性 */
    setBudgetAndBidFormProperty() {
      const { delivery_mode } = this.adConfig.basic_set_form.config;
      const { budget, cpa_bid, deep_cpabid, roi_goal } = this.adData.budget_and_bid_form.config;
      // 【投放模式】是否是自动投放
      const is_procedural = delivery_mode?.value === 'PROCEDURAL';
      if (is_procedural && !delivery_mode?.hidden) {
        budget.hidden = is_procedural;
        cpa_bid.hidden = is_procedural;
        deep_cpabid.hidden = is_procedural;
        roi_goal.hidden = is_procedural;
      }
      /** 设置【广告预算与出价】显示隐藏 */
      this.adData.budget_and_bid_form.hidden = budget.hidden && cpa_bid.hidden && deep_cpabid.hidden && roi_goal.hidden;
    },
    /** 打开小游戏链接弹窗 */
    openMiniProgramInfoUrl() {
      this.mini_program_info_url_dialog_config.is_show = true;
    },
    /**
     * 确认小游戏链接弹窗
     * @param {Object} data 小游戏链接数据
     */
    miniProgramInfoUrlConfirm(data) {
      this.mini_program_info_url_dialog_config.is_show = false;
      const { mini_program_info_url } = this.adData.material_form.config.promotion_materials.children;
      mini_program_info_url.value = data.link;
    },
    /**
     * 设置素材数量上限
     * @returns {void}
     */
    setMaterialLimit() {
      const { landing_type, app_promotion_type, delivery_mode } = this.adConfig.basic_set_form.config;
      // 【推广目标】是否是小游戏
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      // 【推广子目标】是否是预约下载
      const is_reserve = app_promotion_type.value === 'RESERVE';
      // 【推广子目标】是否是应用下载
      const is_download = app_promotion_type.value === 'DOWNLOAD';
      // 【投放模式】是否是自动投放
      const is_procedural = delivery_mode?.value === 'PROCEDURAL';

      const is_30_limit = (is_micro_game && is_procedural) || (!is_micro_game && (is_reserve || is_download) && is_procedural);
      const { material } = this.adData.material_form.config.promotion_materials.children;
      material.limit = is_30_limit ? 30 : 10;
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-name {
  margin-left: 10px;
  &::before {
    content: '*';
    color: #ff4949;
    margin-right: 4px;
  }
}
.named-insert {
  margin-left: 10px;
  .el-link {
    color: #5489f2;
    padding: 10px;
  }
}
.ad-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  .ad-column {
    flex: 1;
  }
}
</style>

<style lang="scss">
.jrtt-ad-batch-container {
  label[for="promotion_materials.children.mini_program_info_url.value"] {
    &+.el-form-item__content {
      display: flex;
    }
  }
}
</style>
